import { combineReducers } from "redux";
import { ActionSchema } from "../actions";
import { GetScriptsSchema, GetWorkflowsSchema, WorkflowConst } from "../actions/workflowActions";
import scriptMutationsReducer, { ScriptMutationState } from "../features/orchestration/scriptMutations";
import workflowMutationsReducer, { WorkflowMutationState } from "../features/orchestration/workflowMutations";

const getAllWorkflowsReducer = (state = {}, action: ActionSchema<GetWorkflowsSchema>) => {
  switch (action.type) {
    case WorkflowConst.GET_ALL_WORKFLOWS_SUCCESS:
    case WorkflowConst.GET_ALL_WORKFLOWS_LOADING:
    case WorkflowConst.GET_ALL_WORKFLOWS_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const getAllScriptsReducer = (state = {}, action: ActionSchema<GetScriptsSchema>) => {
  switch (action.type) {
    case WorkflowConst.GET_ALL_SCRIPTS_SUCCESS:
    case WorkflowConst.GET_ALL_SCRIPTS_LOADING:
    case WorkflowConst.GET_ALL_SCRIPTS_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export interface WorkflowSchema {
  allWorkflows: GetWorkflowsSchema;
  allScripts: GetScriptsSchema;
  workflowTemplates: any;
  workflowMutations: WorkflowMutationState;
  scriptMutations: ScriptMutationState;
}

const getWokflowTemplatesReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case WorkflowConst.INIT_WORKFLOW_TEMPLATE_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const workflowReducer = combineReducers({
  allWorkflows: getAllWorkflowsReducer,
  allScripts: getAllScriptsReducer,
  workflowTemplates: getWokflowTemplatesReducer,
  workflowMutations: workflowMutationsReducer,
  scriptMutations: scriptMutationsReducer
});

export default workflowReducer;
